import { useSelector } from "react-redux";

import styled, { keyframes } from 'styled-components';
import icons from '../../assets/sprite.svg';

const ShipsInfo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 600px;
    color: ${props => props.owner === 'player' ? 
        props.isPlayerTurn ? 'darkgreen' : 'darkslategray' : 
        props.isPlayerTurn ? 'darkslategray' : '#8B0000'};
    div:first-of-type {
        width: 150px;
        font-size: 150%;
        margin: 0 auto;
    }
    div {
        margin: 0 auto;
        width: 10%;
    }
    svg {
        width: 40px;
        height: 40px;
        margin: 0 auto;
        fill: ${props => props.owner === 'player' ? 
            props.isPlayerTurn ? 'darkgreen' : 'darkslategray' : 
            props.isPlayerTurn ? 'darkslategray' : '#8B0000'};
    }
`;

const SingleStat = styled.div`
    display: flex;
    flex-direction: column;
`;

const appear = keyframes`
    from {
        opacity: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

const AnimatedDigit = styled.span`
    font-size: 200%;
    margin: 0 auto;
    animation: ${appear} 1s ease-out;
`;

const ShipStat = ({ owner, isPlayerTurn }) => {
    const stat = useSelector(state => owner === 'player' ? state.player.shipsStats : state.computer.shipsStats);

    const renderShipsStat = () => {
        return (
            Object.values(stat).map((item, index) => {
                return (
                    <SingleStat key={index}>
                        {String.fromCodePoint(9634).repeat(index + 1)}
                        <AnimatedDigit key={index + 1 + 'deck' + item}>
                            {item}
                        </AnimatedDigit>
                    </SingleStat>
                );
            })
        );
    };

    const shipsStat = renderShipsStat();

    return (
        <ShipsInfo owner={owner} isPlayerTurn={isPlayerTurn}>
            <div>{owner}</div>
            <svg>
                <use href={icons + '#ship'}/>
            </svg>
            {shipsStat}
        </ShipsInfo>
    )
}

export default ShipStat;